/**
 * Float-histogram semantic palette — the SINGLE source of truth for the four
 * bucket colours, imported by BOTH consumers:
 *   - the PDF builder (float-histogram-builder.js, the 7-bucket shape), and
 *   - the dashboard FloatHistogram (the engine 5-bucket shape).
 *
 * V-15 consolidation (amendment v3.23). The ruled F-4 palette (amendment v3.19
 * §10/§11) previously lived duplicated in both consumers — correct in both, but
 * copied. This module is the one exported definition; the values are UNCHANGED
 * (byte-identical hex per bucket), so no rendered colour moves.
 *
 * The ruled semantics: the healthy band (Low Float, 11–44 d) is the ONLY green;
 * negative is critical red; zero, near-critical (1–10) and every excessive band
 * are warning amber; no-data is neutral grey.
 * @module pdf/helpers/float-histogram-palette
 */
export const HISTOGRAM_PALETTE = Object.freeze({
  critical: '#C0392B',
  warning: '#D4880F',
  pass: '#1E8449',
  grey: '#6C757D',
});
